<template>
<div id="App">
  <Navigation/>
  <transition
    @enter="enter" @after-enter="afterEnter"
    @leave="leave" @after-leave="afterLeave"
    @before-enter="beforeEnter"
    :css="false" appear :mode="mode">
    <router-view ref="page" v-if="loaded"/>
  </transition>
  <Loader v-if="!loaded && !$root.isIE"/>
  <Panel v-if="$route.meta.name != 'chapters' && loaded" />
  <Analytics />
  <Landscape/>
  <Sniffer v-if="$root.isIE"/>
  <Edge v-if="$root.isEDGE"/>
</div>
</template>

<script>
import Loader from '@/components/loader/Loader'
import Navigation from '@/components/navigation/Navigation'
import Transition from '@/core/mixins/Transition'
import Panel from '@/components/panel/Panel'
import Landscape from '@/components/landscape/Landscape'
import Sniffer from '@/components/sniffer/Sniffer'
import Edge from '@/components/sniffer/Edge'
import Analytics from '@/components/analytics/Analytics'

export default {
  name: 'App',
  mixins: [ Transition ],
  components: { Loader, Navigation, Panel, Landscape, Analytics, Sniffer, Edge },
  computed: {
    loaded() { return this.$store.getters['loader/loaded'] },
  },
  created() {
    // console.log(this.$store.getters['data/general'])
    // console.log(this.$store.getters['data/pages'])
  }
}
</script>

<style lang="stylus">
@import '~reset-css/reset.css'
@import '~@/config/Settings'
@import '~@/commons/fonts/Fonts'
@import '~@/commons/stylus/Global'
@import '~@/commons/stylus/Page'
@import '~@/commons/stylus/Vlazy'

#App
  height 100%
  overflow hidden
</style>
